export default {
    id: null,
    isLoading: true,
    conversations: [],
    activeConversation: null,
    searchQuery: '',
    recipients: [],
    errors: {
        input: {},
    },
};
